// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__6WRav","loading-icon":"Loading_loading-icon__DKt-z","spline":"Loading_spline__iYH7y"};